import { useEffect, useRef } from "react"
import axios from 'axios';

export default function Paypal({ amount = 10, setCheckOut }) {
    const url = process.env.REACT_APP_URL;

    const paypal = useRef()

    useEffect(() => {
        window.paypal.Buttons({
            createOrder: (data, actions, err) => {
                return actions.order.create({
                    intent: "CAPTURE",
                    purchase_units: [
                        {
                            description: "Donate to foundation",
                            amount: {
                                currency_code: "USD",
                                value: amount
                            }
                        }
                    ]
                })
            },
            onApprove: async (data, actions) => {
                const order = await actions.order.capture();

                const addressObj = order.purchase_units[0].shipping.address;

                try {
                    await axios.post(url + '/save', {
                        given_name: order.payer.name.given_name,
                        surname: order.payer.name.surname,
                        email: order.payer.email_address,
                        phone: order.payer?.phone?.phone_number?.national_number || null,
                        adress: `${addressObj.address_line_1}, ${addressObj.admin_area_2}, ${addressObj.admin_area_1} ${addressObj.postal_code}, ${addressObj.country_code}`,
                        amount: order.purchase_units[0].amount.value,
                        pyp_id: order.id,
                    });

                    setCheckOut(false); // ✅ hide the PayPal UI

                    // ✅ delay alert slightly to avoid blocking PayPal cleanup
                    setTimeout(() => {
                        if (order.status === "COMPLETED") {
                            alert("✅ Transaction completed successfully!");
                        } else {
                            alert("❌ Transaction failed.");
                        }
                    }, 100);
                } catch (error) {
                    console.error("Saving donation failed", error);
                    alert("❌ Something went wrong while saving your donation.");
                }
            },
            onError: (err) => {
                console.log(err);
                setCheckOut(false);
            }
        }).render(paypal.current);
        // eslint-disable-next-line
    }, []);


    return (
        <div className="ml-10">
            <div className="" ref={paypal}></div>
            <div className="text-white  cursor-pointer hover:opacity-75 flex items-center justify-center" onClick={() => { setCheckOut(false) }}>
                <span className="bg-red-500 p-1 rounded">Cancel</span>
            </div>
        </div >
    )
}